import {
  Backdrop, Button, Card, CardActions, CardContent, CardHeader, Checkbox, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogTitle, Divider,
  FormControl, Grid, Input, InputAdornment, LinearProgress, Slide, Slider, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography
} from '@material-ui/core';
import { SearchIcon } from '@material-ui/data-grid';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import CloseIcon from '@material-ui/icons/Close';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import QueueIcon from '@material-ui/icons/Queue';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { CustomTableCell } from 'src/components/CustomTableCell';
import Page from 'src/components/Page';
import AddressSearch from 'src/components/Selects/AddressSearch';
import axios from 'src/utils/axios';
import {
  getSepetAdet, getUser, sc, setSepetAdet
} from 'src/utils/Common';


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  cardUstBolum: {
    maxHeight: 700,
    minHeight: 700,
    width: '100%'
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  container: {
    maxHeight: 497,
    minHeight: 497,
    mimWidth: 500
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  rootAdresSearch: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(0)
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Reset() {
  const classes = useStyles();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [LoadingMaterial, setLoadingMaterial] = React.useState(true);
  const [bultenOpen, setBultenOpen] = React.useState(false);
  const [bultenParam, setBultenParam] = React.useState('');
  const [openMaterialFileTitle, setOpenMaterialFileTitle] = React.useState('');
  const [openMaterialFile, setOpenMaterialFile] = React.useState(false);
  const [ImageUrl, setImageUrl] = useState(null);
  const [SiparisAdetTitle, setSiparisAdetTitle] = React.useState('');
  const [siparisAdet, setsiparisAdet] = React.useState(1);
  const [openSiparisAdet, setopenSiparisAdet] = React.useState(false);
  const [Loading, setLoading] = useState(false);
  const [MalzemeSiparis, setMalzemeSiparis] = React.useState('');
  const SessionUser = getUser();
  const [WarehouseAddress, setWarehouseAddress] = useState([]);
  const [SayimData, setSayimData] = useState([]);
  const [SayimDataMain, setSayimDataMain] = useState([]);
  const [previous, setPrevious] = React.useState({});
  const [selected, setSelected] = React.useState([]);
  const [SayimArama, setSayimArama] = React.useState("");
  const [MalzemeEkle, setMalzemeEkle] = React.useState("");
  const [Adresrow, setAdresrow] = useState([{ WarehouseAddress: 0, WarehouseAddressText: '', Malzemeleri: '' }]);

  const onChangeSelectWarehouse = (valueParam, nameParam, row) => {
    if (!previous[row.MALZEME_STOK_NO]) {
      setPrevious(state => ({ ...state, [row.MALZEME_STOK_NO]: row }));
    }
    const value = valueParam;
    const name = nameParam;

    const newRows = SayimData.map(item => {
      if (
        item.MALZEME_STOK_NO === row.MALZEME_STOK_NO &&
        item.FIS_NO === row.FIS_NO
      ) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setSayimData(newRows);
    setSayimDataMain(newRows);
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const handleCloseSiparisAdet = () => {
    setopenSiparisAdet(false);
    setsiparisAdet(1);
  };
  const handleSliderChange = (event, newValue) => {
    setsiparisAdet(newValue);
    if (Number(newValue) < 0) {
      setsiparisAdet(0);
    } else if (Number(newValue) > 999) {
      setsiparisAdet(999);
    }
  };
  const GetMaterialBulletin = (event, materialCode) => {
    setBultenParam(materialCode);
    setBultenOpen(true);
    setLoadingMaterial(false);
  };
  const handleInputChange = event => {
    setsiparisAdet(event.target.value === '' ? '' : Number(event.target.value));
    if (Number(event.target.value) < 0) {
      setsiparisAdet(0);
    } else if (Number(event.target.value) > 999) {
      setsiparisAdet(999);
    }
  };



  const setMaterialResetAccept = () => {
    setLoading(true);
    axios
      .get(
        `/SetMaterialReset/${SessionUser.ServiceShopId}/${SessionUser.OrganizationUserId}/${0}`
      )
      .then(response => {
        if (response.data[0].ErrorCode === 0) {
          setUyariTip('success');
          setUyariAciklama('İşleminiz başarı ile gerçekleştirildi!...');
          setUyari(true);
        } else {
          setUyariTip('error');
          setUyariAciklama(response.data[0].ErrorDescription);
          setUyari(true);
        }
        setLoading(false);

      })
      .catch(error => {
        setLoading(false);
      });
  }

  const setMaterialReset = () => {
    confirmAlert({
      message: "Deponuzdaki tüm adreslerdeki malzeme adedi sıfırlanacaktır. Devam etmek istediğinize emin misiniz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => setMaterialResetAccept()
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });

  }


  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="Oasis Yönetimi Depo Kayıtları Sil" />
          <Divider />
          <Backdrop className={classes.backdrop} open={Loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Snackbar open={uyari} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyariTip}>
              {uyariAciklama || ''}
            </Alert>
          </Snackbar>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <Card className={classes.cardUstBolum}>
                  <CardHeader
                    title="İşlemler" />
                  <Divider />
                  <CardActions>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12}>
                        <Button
                          variant="contained"
                          className={classes.button}
                          color="secondary"
                          endIcon={<DeleteForeverIcon></DeleteForeverIcon>}
                          onClick={event => setMaterialReset()}
                        >
                          Depo Kayıtlarını Sil
                        </Button>
                      </Grid>
                    </Grid>
                  </CardActions>
                  <Divider />
                  <CardContent style={{ fontSize: 25, color: 'red' }}>
                    Bu işlemi yaptığınızda deponuzdaki tüm adetler sıfırlanacak.
                    <br />
                    Deponuzdaki tüm malzemeleri tekrar saymanız gerekecek!...
                    <br />
                    Zimmetler değiştirilmeyecek.
                    <br />
                    Geçmiş malzeme hareketleri ve tarihçe silinmeyecektir.
                    <br />
                    Bu işlem geri alınamaz depoyu sıfırlayarak sayım yapmak istediğinize emin misiniz?
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>

    </Page >
  );
}

export default Reset;
